/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect, useCallback } from 'react';
import { GridColumns } from '@mui/x-data-grid';
import { useNavigate } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import { Laundry } from '../../entities';
import { useLaundries } from '../../hooks';
import { DataTable } from '../../components';
import MainContainer from '../../components/MainContainer';

export const Laundries = (): JSX.Element => {
  const history = useNavigate();
  const [laundries, setLaundries] = useState<Laundry[]>([] as Laundry[]);
  const { enqueueSnackbar } = useSnackbar();
  const laundriesRepository = useLaundries();

  const headers: GridColumns = [
    {
      field: 'id',
      headerName: 'Id',
      disableColumnMenu: true,
      editable: false,
      disableExport: true,
      disableReorder: true,
      hideable: false,
      filterable: false,
      sortable: false,
      width: 62,
      align: 'center',
      hideSortIcons: true,
    },
    { field: 'vendor', headerName: 'Vendor', editable: false, flex: 1 },
    { field: 'ideologica_client_id', headerName: 'ClientId', editable: false, flex: 2 },
    { field: 'ideologica_company_id', headerName: 'CompanyId', editable: false, flex: 2 },
    { field: 'ideologica_service_id', headerName: 'ServiceId', editable: false, flex: 2 },
    { field: 'ideologica_store_id', headerName: 'StoreId', editable: false, flex: 2 },
    { field: 'ideologica_base_url', headerName: 'Url', editable: false, flex: 2 },
  ];

  useEffect(() => {
    async function getLaundries() {
      try {
        const response = await laundriesRepository.fetchAll();
        setLaundries(response);
      } catch (error) {
        enqueueSnackbar('Falha ao buscar as lavanderias', { variant: 'error' });
      }
    }

    getLaundries();
  }, []);

  const handleEdit = useCallback(
    (laundry: Laundry) => {
      history(`/laundries/${laundry.id}/garments`);
    },
    [history]
  );

  return (
    <MainContainer>
      <DataTable
      rows={laundries || []}
      columns={headers}
      showOnChangeImport
      onRowClick={({ row }) => handleEdit(row as any)}
      />
    </MainContainer>
  );
};

export default Laundries;
